export default __webpack_public_path__ + "static/media/Gida of the Cloudcleaver.8b31e2a9.jpg";